var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inner-wrapper"},[_c('default-layout',[_c('nuxt'),_vm._v(" "),(_vm.canAccess)?_c('page-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }